export enum ErrorCode {
  AUTH_ERROR = 'AuthError',
  BACKEND_ERROR = 'BackEndError',
  BAD_GATEWAY = 'BadGateway',
  BAD_REQUEST = 'BadRequest',
  DATA_INVALID = 'DataInvalid',
  INVALID_CONTRACT = 'InvalidContract',
  INVALID_STATUS_CHECK_KEY = 'InvalidStatusCheckKey',
  MISSING_MANDATORY_FIELD = 'MissingMandatoryField',
  MULTIPLE_CHOICES = 'MultipleChoices',
  NOT_FOUND = 'NotFound',
  TOKEN_INVALID = 'TokenInvalid'
}
